import React from "react";

function ErrorPage() {
  return (
    <div className="content d-flex justify-content-center align-items-center">
      {/* Container */}
      <div className="flex-fill">
        {/* Error title */}
        <div className="text-center mb-3">
          <h1 className="error-title">404</h1>
          <h5>Уучлаарай, хуудас олдсонгүй. Хуудсын замыг шалгана уу!</h5>
        </div>
        {/* /error title */}
        {/* /error wrapper */}
      </div>
      {/* /container */}
    </div>
  );
}

export default ErrorPage;
